<div>
  <p>{{ data.result }}</p>
  <button mat-button (click)="closeDialog()" i18n>Close</button>
  </div>


// WEBPACK FOOTER //
// ./src/app/timereport/timereport-add/timereport-add.component.ts.AddTimereportDialogComponent.html